import React from 'react';
import { useTranslation } from 'react-i18next';

import { TabsType } from '../utils';
import styles from './EmptyState.module.scss';

export interface EmptyStateProps {
  activeTab: TabsType;
}

export const EmptyState = ({ activeTab }: EmptyStateProps) => {
  const { t } = useTranslation(['calendar']);

  return (
    <div className={styles.emptyStateRoot} data-testid="empty-state">
      <img src="/app/static/images/calendar/no-events.svg" alt="" />
      <p className={styles.description} data-testid="state-description">
        {/* i18next-extract-mark-context-next-line ["earnings", "economics", "company"]  */}
        {t('calendar:emptyState', {
          context: activeTab,
        })}
      </p>
    </div>
  );
};
